export default "__VITE_ASSET__KcYpegDE__"